import { useParams, Link } from "react-router-dom";
import { Reveal } from "../components/Reveal";

const lastUpdated = "10 février 2026";

const cookies = {
  title: "Politique de cookies",
  intro:
    "EVARA Monaco utilise des cookies et technologies similaires afin de garantir le bon fonctionnement de son site, mesurer son audience et améliorer l'expérience de ses visiteurs. La présente politique précise quels cookies sont utilisés, dans quel but, et comment vous pouvez les gérer.",
  sections: [
    {
      title: "1. Qu'est-ce qu'un cookie ?",
      body: "Un cookie est un petit fichier texte déposé sur votre terminal (ordinateur, tablette ou smartphone) lors de la consultation d'un site web. Il permet au site de reconnaître votre navigateur et de mémoriser certaines informations relatives à votre navigation.",
    },
    {
      title: "2. Types de cookies utilisés",
      body: "EVARA Monaco utilise trois catégories de cookies : (a) des cookies strictement nécessaires au fonctionnement du site et à la sécurisation de votre session ; (b) des cookies de mesure d'audience destinés à comprendre la fréquentation et à améliorer le contenu ; (c) des cookies tiers déposés par des services intégrés (Google Maps, Calendly) lorsque vous interagissez avec eux.",
    },
    {
      title: "3. Durée de conservation",
      body: "Les cookies que nous déposons ont une durée de vie maximale de 13 mois, conformément aux recommandations de la CNIL. À l'issue de ce délai, votre consentement est à nouveau sollicité.",
    },
    {
      title: "4. Gestion de vos préférences",
      body: "Vous pouvez à tout moment retirer votre consentement et paramétrer votre navigateur afin de refuser tout ou partie des cookies. Chaque navigateur propose des modalités de configuration différentes — vous trouverez les instructions dans la rubrique d'aide de votre navigateur (Chrome, Safari, Firefox, Edge).",
    },
    {
      title: "5. Contact",
      body: "Pour toute question relative à notre politique de cookies, vous pouvez nous écrire à evara.monaco@gmail.com.",
    },
  ],
};

const mentions = {
  title: "Mentions légales",
  intro:
    "Conformément aux dispositions légales en vigueur, les utilisateurs du site evara-monaco.com sont informés des mentions suivantes.",
  sections: [
    {
      title: "1. Éditeur du site",
      body: "Le site evara-monaco.com est édité par EVARA Monaco, agence de création visuelle et marketing digital, dirigée par sa fondatrice Ilona Marchi. Siège : Monaco, 98 000. Téléphone : +33 7 89 33 55 68. E-mail : evara.monaco@gmail.com.",
    },
    {
      title: "2. Directrice de la publication",
      body: "La directrice de la publication est Ilona Marchi, fondatrice d'EVARA Monaco.",
    },
    {
      title: "3. Hébergeur",
      body: "Le site est hébergé par Emergent (informations de l'hébergeur disponibles sur demande à evara.monaco@gmail.com).",
    },
    {
      title: "4. Propriété intellectuelle",
      body: "L'ensemble des éléments du site evara-monaco.com — textes, images, logos, vidéos, charte graphique, identité visuelle — est la propriété exclusive d'EVARA Monaco ou de ses partenaires. Toute reproduction, représentation, modification ou exploitation, totale ou partielle, est strictement interdite sans autorisation écrite préalable.",
    },
    {
      title: "5. Responsabilité",
      body: "EVARA Monaco met tout en œuvre pour assurer l'exactitude des informations diffusées sur le site, mais ne saurait être tenue responsable des erreurs, omissions ou de l'usage qui pourrait en être fait par des tiers.",
    },
    {
      title: "6. Droit applicable",
      body: "Les présentes mentions légales sont régies par le droit monégasque. Tout litige relatif à l'utilisation du site relèvera de la compétence exclusive des juridictions de Monaco.",
    },
  ],
};

const confidentialite = {
  title: "Politique de confidentialité",
  intro:
    "EVARA Monaco accorde une grande importance à la protection des données personnelles de ses visiteurs, prospects et clients. Cette politique décrit les données que nous collectons, les finalités de leur traitement et les droits dont vous disposez, conformément au Règlement Général sur la Protection des Données (RGPD).",
  sections: [
    {
      title: "1. Responsable du traitement",
      body: "Le responsable du traitement est EVARA Monaco, représenté par Ilona Marchi. Pour toute question relative à vos données personnelles, vous pouvez nous contacter à evara.monaco@gmail.com.",
    },
    {
      title: "2. Données collectées",
      body: "Nous collectons uniquement les données strictement nécessaires à nos services : (a) lors d'une demande d'échange ou de rendez-vous : prénom, nom, adresse e-mail ; (b) lors d'une inscription à notre newsletter : adresse e-mail ; (c) lors d'une prise de contact : nom, e-mail, téléphone, secteur d'activité, budget, message ; (d) données techniques de navigation via cookies (voir notre Politique de cookies).",
    },
    {
      title: "3. Finalités du traitement",
      body: "Vos données sont collectées et traitées afin de : répondre à vos demandes de contact et de rendez-vous, vous adresser nos actualités lorsque vous y avez consenti, améliorer la qualité de nos services et respecter nos obligations légales et fiscales.",
    },
    {
      title: "4. Base légale",
      body: "Les traitements reposent sur votre consentement (newsletter, cookies non essentiels), sur l'exécution de mesures précontractuelles (contact et prise de rendez-vous), et sur nos intérêts légitimes (sécurité du site, amélioration des services).",
    },
    {
      title: "5. Durée de conservation",
      body: "Les données issues des formulaires sont conservées pendant 3 ans à compter du dernier contact. Les données newsletter sont conservées jusqu'à votre désinscription. Les données comptables sont conservées pendant 10 ans conformément aux obligations légales.",
    },
    {
      title: "6. Destinataires",
      body: "Vos données sont strictement destinées à l'équipe d'EVARA Monaco. Elles ne sont ni vendues, ni cédées à des tiers à des fins commerciales. Elles peuvent être transmises à nos sous-traitants techniques (hébergeur, outils d'envoi d'e-mail) qui agissent sur nos instructions et présentent les garanties de sécurité requises.",
    },
    {
      title: "7. Vos droits",
      body: "Conformément au RGPD, vous disposez d'un droit d'accès, de rectification, d'effacement, d'opposition, de limitation du traitement et de portabilité de vos données. Vous pouvez exercer ces droits en écrivant à evara.monaco@gmail.com. Vous disposez également du droit d'introduire une réclamation auprès de l'autorité de contrôle compétente.",
    },
    {
      title: "8. Sécurité",
      body: "EVARA Monaco met en œuvre les mesures techniques et organisationnelles appropriées pour protéger vos données contre toute perte, altération ou accès non autorisé.",
    },
  ],
};

const CONTENT = {
  cookies,
  mentions,
  confidentialite,
};

const Legal = () => {
  const { slug } = useParams();
  const data = CONTENT[slug];

  if (!data) {
    return (
      <main data-testid="page-legal" className="bg-white pt-40 pb-32 px-6 min-h-[80vh]">
        <div className="max-w-3xl mx-auto text-center">
          <h1 className="font-serif text-4xl text-[#1A1528] mb-6">Page introuvable</h1>
          <Link to="/" className="btn-violet">Retour à l'accueil</Link>
        </div>
      </main>
    );
  }

  return (
    <main data-testid={`page-legal-${slug}`} className="bg-white">
      {/* HERO */}
      <section className="pt-40 pb-12 px-6 bg-[#FFFBEA]">
        <div className="max-w-4xl mx-auto">
          <Reveal>
            <h1 className="font-serif text-4xl md:text-6xl font-bold text-[#1A1528]">
              {data.title}
            </h1>
            <p className="mt-4 text-sm uppercase tracking-[0.2em] text-[#6B5CE7]">
              Dernière mise à jour · {lastUpdated}
            </p>
          </Reveal>
        </div>
      </section>

      {/* CONTENT */}
      <section className="py-20 md:py-28 px-6">
        <div className="max-w-3xl mx-auto">
          <Reveal>
            <p className="text-[#4A4558] font-light text-base md:text-lg leading-relaxed mb-12">
              {data.intro}
            </p>
          </Reveal>

          <div className="space-y-10">
            {data.sections.map((section, i) => (
              <Reveal key={section.title} delay={i * 0.05}>
                <article data-testid={`legal-section-${i}`}>
                  <h2 className="font-serif text-xl md:text-2xl text-[#1A1528] font-semibold mb-3">
                    {section.title}
                  </h2>
                  <p className="text-[#4A4558] font-light text-base leading-relaxed">
                    {section.body}
                  </p>
                </article>
              </Reveal>
            ))}
          </div>

          <Reveal delay={0.2}>
            <div className="mt-16 pt-10 border-t border-[#F5E6A3]/70 flex flex-col md:flex-row justify-between items-start md:items-center gap-6">
              <p className="text-sm text-[#4A4558] font-light max-w-md">
                Une question concernant ces conditions ? Écrivez-nous à
                <a
                  href="mailto:evara.monaco@gmail.com"
                  className="text-[#6B5CE7] hover:underline ml-1"
                >
                  evara.monaco@gmail.com
                </a>.
              </p>
              <Link to="/" data-testid="legal-back-home" className="btn-violet shrink-0">
                Retour à l'accueil
              </Link>
            </div>
          </Reveal>
        </div>
      </section>
    </main>
  );
};

export default Legal;
